import api from "@core/plugins/api";
import { JavascriptHelpers, ArrayHelpers } from "@core/helpers";

const getLocationOptionsUrl = (query) => `cdi-candidate/et/locations?${query}`;
const getLanguageOptionsUrl = () => `cdi-candidate/et/languages`;
const getExperienceOptionsUrl = () => `cdi-candidate/et/year_experiences`;

export class RecruitmentCandidatesFiltersService {
  static async getLocationOptions({ city } = {}) {
    try {
      const query = JavascriptHelpers.getUrlFilters({ q: city });
      const { data } = await api.private.get(getLocationOptionsUrl(query));
      return ArrayHelpers.ensureArray(data);
    } catch (error) {
      throw error;
    }
  }

  static async getLanguageOptions() {
    try {
      const { data } = await api.private.get(getLanguageOptionsUrl());
      return ArrayHelpers.ensureArray(data);
    } catch (error) {
      throw error;
    }
  }

  static async getExperienceOptions() {
    try {
      const { data } = await api.private.get(getExperienceOptionsUrl());
      return ArrayHelpers.ensureArray(data);
    } catch (error) {
      throw error;
    }
  }
}
